import { FC, Suspense } from "react";

import type {
  IBulkUpdateBookingsDateTimeProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import { BulkUpdateBookingsDateTimeSuspended } from "./bulk-update-bookings-date-time";

/** The drawer registry mounts this; the panel itself suspends while the selection resolves. */
export const BulkUpdateBookingsDateTime: FC<
  IBulkUpdateBookingsDateTimeProps & IInjectedDrawerProps
> = props => (
  <Suspense>
    <BulkUpdateBookingsDateTimeSuspended {...props} />
  </Suspense>
);
